/* eslint react/no-set-state: 0 */
import React, { PropTypes } from 'react';
import { TileLayer, GeoJson } from 'react-leaflet';
import { connect } from 'reflux';
//import BoundsMap from '../leaflet/bounds-map';
import RegionsActions from '../../actions/regions';
import Regions from '../../stores/regions';
import CoverageActions from '../../actions/coverage';
import CoverageData from '../../stores/coverage';
import ProjctsActions from '../../actions/budget';
import ProjectsPoints from '../../stores/budget';
import ZonesActions from '../../actions/zones';
import ZonesLayer from '../../stores/zones';
import HeatmapLayer from '../leaflet/HeatmapLayer';
import { Map } from 'react-leaflet';
//import AppActions from '../../actions/app';
import AppStore from '../../stores/app';
import MapMenu from  '../boilerplate/mapmenu';
import ProjectsLayer from './projectslayer';
import Legend from './legend';
import MarkerCluster from './MarkerCluster';
//import T from '../misc/t';

require('stylesheets/map/map');

const gradient = { '0.1': '#edf8fb', '0.2': '#ccece6', '0.4': '#99d8c9', '0.6': '#66c2a4', '0.8': '#2ca25f', '1.0': '#006d2c'};

const MainMap = React.createClass({
  mixins: [
    connect(Regions, 'regions'),
    connect(ZonesLayer, 'zones'),
    connect(CoverageData, 'coverage'),
    connect(ProjectsPoints, 'projectspoints'),
    connect(AppStore, 'app'),
  ],

  componentWillMount() {
    RegionsActions.loadRegions();
    ProjctsActions.loadProjects();
    CoverageActions.loadCoverage();
    ZonesActions.loadZones();

  },

  PropTypes: {
    newMarkerData: PropTypes.array.isRequired,
  },

  onEachFeature(feature, layer) {
    if (feature.properties && feature.properties.popupContent) {
      layer.bindPopup(feature.properties.popupContent);
    }
  },

  render() {
    let colorizedZones = null;
    if (this.state.app.selected === 'zones' ) {
      colorizedZones = (<GeoJson data = {this.state.zones.zones} map="MainMap" onEachFeature= {this.onEachFeature}
          style = {
          function(feature) {
            if (feature.style) {
              return feature.style;
            } else {
              return  {
                weight: 2,
                opacity: 1,
                color: 'black',
                fillOpacity: 0,
                fillColor: '#fee5d9'};
            }
          }
      }/>);
    }

    let colorizedData = null;
    if (this.state.regions.regions && this.state.app.selected === 'counties' || this.state.app.selected === 'projects') {
      colorizedData = (<GeoJson data = {this.state.regions.regions} map="MainMap" onEachFeature= {this.onEachFeature}
          style = {
          function(feature) {
            if (feature.style) {
              return feature.style;
            } else {
              return  {
                weight: 2,
                opacity: 1,
                color: 'white',
                fillOpacity: 0,
                fillColor: '#fee5d9'};
            }
          }
      }/>);
    }

    let heats = null;
    if (this.state.projectspoints.length > 0 && this.state.app.selected === 'heats') {
      heats = (<HeatmapLayer
          blur = {30}
          fitBoundsOnLoad = {true}
          gradient={gradient}
          intensityExtractor={m => parseFloat(m.total_estimates_for_2015)}
          latitudeExtractor={m => m.location[0]}
          longitudeExtractor={m => m.location[1]}
          minOpacity={0.5}
          points={this.state.projectspoints}/>);
    }

    let porjects = null;
    if (this.state.projectspoints.length > 0 && this.state.app.selected === 'projects') {
      porjects = (<ProjectsLayer
          latitudeExtractor={m => m.location[0]}
          longitudeExtractor={m => m.location[1]}
          map = {Map}
          points={this.state.projectspoints}/>);
    }

    let Cluster = null;;
    if (this.state.projectspoints.length > 0 && this.state.app.selected === 'projects'){
      Cluster = (<MarkerCluster newMarkerData = {this.state.projectspoints} type="point"/>);
    }
    return (
      <div className="main-map">
        <div className="map-container">
        <MapMenu/>
            <Map
                center={[0.21, 37.9]}
                className="leaflet-map"
                zoom={6}>
                <TileLayer url="//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                {colorizedData}
                {colorizedZones}
                {heats}
                {Cluster}
                <Legend />
            </Map>
         </div>
      </div>
    );
  },
});

export default MainMap;



/** WEBPACK FOOTER **
 ** ./app/scripts/components/map/mainmap.jsx
 **/